import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PartnerIntegrations, } from '@dixa/lib-integrations-partner-widgets';
import { FlexBox, Text } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { config } from 'lib-shared-backend-config';
import { useCallback, useLayoutEffect } from 'react';
import { SidebarToggleTrigger } from 'components/conversation/components/sidebar/SidebarToggleTrigger';
import { notificationActions } from 'components/notifications/actions/notification';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { useBreakpointValue } from 'utils/mediaQuery';
import { usePartnerWidgetFeatureFlags } from 'utils/partnerIntegrationsWidget/usePartnerWidgetFeatureFlags';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import ContactCard from '../../components/sidebar/cards/ContactCard';
import FeedbackCard from '../../containers/sidebar/cards/feedbackCard';
import { ConversationSummaryCard } from './cards/ConversationSummaryCard';
import { CustomCards } from './cards/CustomCards';
import { SuggestionCards } from './cards/KnowledgeCard';
import { ConversationCustomFieldsCard } from './cards/customFields';
import { HistoryCard } from './cards/historyCard/HistoryCard';
import { UserTrackingCard } from './cards/userTrackingCard';
import { asPartnerIntegrationUser, partnerIntegrationNotificationTimeout, } from './partnerIntegrations';
const ConversationSidebar = ({ metaConversation, conversationCardsSettings, updateConversationCards, feedback, isMenuOpen, toggleCustomCardMenu, hasCollapseTrackingCard, showTrackingCard, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const dispatch = useAppDispatch();
    const isSmallLayout = useBreakpointValue({
        base: true,
        lg: false,
    });
    const { partnerIntegrationsWidget, customFields, keyIssueExtraction } = useFeatureFlag([
        'partner-integrations-widget',
        'custom-fields',
        'key-issue-extraction',
    ]);
    const partnerWidgetFeatureFlags = usePartnerWidgetFeatureFlags();
    const isCardOpen = (key) => {
        var _a;
        return (_a = conversationCardsSettings[key]) !== null && _a !== void 0 ? _a : false;
    };
    const toggleCard = (key) => {
        updateConversationCards({ key, value: !isCardOpen(key) });
    };
    const toggleSidebar = () => {
        toggleCustomCardMenu({
            key: 'isCustomCardMenuOpen',
            value: !isMenuOpen,
        });
    };
    useLayoutEffect(() => {
        if (isSmallLayout) {
            toggleCustomCardMenu({
                key: 'isCustomCardMenuOpen',
                value: false,
            });
        }
    }, [isSmallLayout, toggleCustomCardMenu]);
    const showNotification = useCallback(({ title, text, icon, severity }) => {
        const time = severity === 'warning' || severity === 'danger'
            ? 0
            : partnerIntegrationNotificationTimeout;
        const className = severity;
        const payload = {
            title,
            text,
            icon,
            className,
            time,
        };
        dispatch(notificationActions.notificationAdd(payload));
    }, 
    // We only pass this into PartnerIntegrations component as a callback
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const rootClassName = classnames('conversation-sidebar-holder', {
        closed: !isMenuOpen,
    });
    const { direction, initial_channel: channel, attributes, } = metaConversation.conversation;
    return (_jsxs("div", Object.assign({ className: rootClassName }, { children: [_jsx(SidebarToggleTrigger, { isMenuOpen: isMenuOpen, toggleSidebar: toggleSidebar }), _jsx(ContactCard, { onToggle: () => toggleCard('contact'), isOpen: isCardOpen('contact'), isMinimized: !isMenuOpen }), keyIssueExtraction &&
                direction === 'inbound' &&
                channel &&
                ['email', 'contactform'].includes(channel) &&
                (attributes === null || attributes === void 0 ? void 0 : attributes.language) === 'en' && (_jsx(ConversationSummaryCard, { isMinimized: !isMenuOpen, conversationIntent: (_b = (_a = metaConversation.conversation) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.messageIntent, conversationIssue: (_d = (_c = metaConversation.conversation) === null || _c === void 0 ? void 0 : _c.attributes) === null || _d === void 0 ? void 0 : _d.keyIssue, conversationName: (_e = metaConversation.requester) === null || _e === void 0 ? void 0 : _e.name, isOpen: isCardOpen('conversation-summary'), onToggle: () => toggleCard('conversation-summary') })), customFields && metaConversation.conversation.id && (_jsx(ConversationCustomFieldsCard, { csid: metaConversation.conversation.id, isMinimized: !isMenuOpen, isOpen: isCardOpen('custom-fields'), onToggle: () => toggleCard('custom-fields') })), metaConversation.requester &&
                metaConversation.previousConversations &&
                ((_f = metaConversation.previousConversations) === null || _f === void 0 ? void 0 : _f.length) !== 0 && (_jsx(HistoryCard, { onToggle: () => toggleCard('history'), isOpen: isCardOpen('history'), previousConversations: metaConversation.previousConversations, requester: metaConversation.requester, isMinimized: !isMenuOpen })), _jsx(SuggestionCards, { isMinimized: !isMenuOpen }), isMenuOpen && (_jsx(FlexBox, Object.assign({ alignItems: "center", padding: "300" }, { children: _jsx(FlexBox, Object.assign({ padding: "200 0" }, { children: _jsx(Text.Paragraph, Object.assign({ variant: "3", subdued: true }, { children: "Integrations" })) })) }))), partnerIntegrationsWidget && (_jsx(PartnerIntegrations, { configuration: {
                    baseUrl: config.url.partnerIntegrations,
                    featureFlags: partnerWidgetFeatureFlags,
                }, conversationContext: {
                    conversationId: ((_g = metaConversation.conversation) === null || _g === void 0 ? void 0 : _g.id) || null,
                    agent: asPartnerIntegrationUser((_h = metaConversation.conversation.assignment) === null || _h === void 0 ? void 0 : _h.agent),
                    customer: asPartnerIntegrationUser(metaConversation.requester),
                }, showNotification: showNotification, onToggleFn: toggleCard, isOpenFn: isCardOpen, isMinimized: !isMenuOpen })), _jsx(CustomCards, { integrations: metaConversation.integrations, async_integrations: (_j = metaConversation.conversation.async_integrations) !== null && _j !== void 0 ? _j : [], isMinimized: !isMenuOpen }), metaConversation.conversation.id && (_jsx(FeedbackCard, { onToggle: () => toggleCard('feedback'), isOpen: isCardOpen('feedback'), feedback: feedback, csid: metaConversation.conversation.id, isMinimized: !isMenuOpen })), showTrackingCard && (_jsx(UserTrackingCard, { onToggle: () => toggleCard('tracking'), isOpen: isCardOpen('tracking'), attributes: (_k = metaConversation.conversation.attributes) !== null && _k !== void 0 ? _k : {}, isMinimized: !isMenuOpen, hasCollapseTrackingCard: hasCollapseTrackingCard }))] })));
};
export default ConversationSidebar;
